import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useContext, useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import React from "react";
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { classNames } from "primereact/utils";
import { Calendar } from 'primereact/calendar';
import { useAuthHeader } from "../../auth/AuthService";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { createAdvertisement, deleteAdvertisement, retrieveAdvertisement, retrieveAdvertisementPhoto, updateAdvertisement, uploadAdvertisement } from "../../Services/Admin/AdvertisementApiService";
import { Dropdown } from "primereact/dropdown";
import { Badge } from "primereact/badge";
import { Checkbox } from "primereact/checkbox";
import { FileUpload } from 'primereact/fileupload';
import { LayoutContext } from "../../Layouts/Admin/layoutcontext";
        
export default function Advertise() {

    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();
    const [advertisements, setAdvertisements] = useState(null);
    const [advertisementDialog, setAdvertisementDialog] = useState(false);
    const [showAdvertisementDialog, setShowAdvertisementDialog] = useState(false);
    const [deleteAdvertisementDialog, setDeleteAdvertisementDialog] = useState(false);
    const [advertisement, setAdvertisement] = useState({});
    const [edit, setEdit] = useState(false);
    const [selectedAdvertisements, setSelectedAdvertisements] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const [filter, setFilter] = useState({'perPage': 10, 'page': 0 });
    const [firstPage, setFirstPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(false);
    const [photo, setPhoto] = useState(null);

    const status = [
        {name : 'Business Day', value: 0},
        {name : 'Advertisement', value: 1},
    ]

    const { setMenuTitle } = useContext(LayoutContext);
    useEffect(() => {
        setMenuTitle('Advertisements');
    },[]);

    useEffect(() => {
        getAdvertisement()
    }, [filter]);

    useEffect(() => {
        getPhoto();
    }, [advertisement.photo])

    const getAdvertisement = async () => {
        setLoading(true);
        await retrieveAdvertisement(authHeader(), filter)
        .then((response) => {
            setAdvertisements(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const getPhoto = async () => {
        setPhoto(null);
        advertisement?.photo && await retrieveAdvertisementPhoto(authHeader(), advertisement?.photo)
        .then((response) => {
            setPhoto(response?.data);
        })
        .catch((error) => console.log(error));
    }

    const onPageChange = (page) => {
        setFirstPage(page.first);
        setFilter({ ...filter,'perPage': page.rows, 'page': page.page});
    }

    const onSort = (sort) => {
        setFilter({...filter, 'sortField': sort.sortField, 'sortOrder': sort.sortOrder});
    }

    const openNew = () => {
        setEdit(false);
        reset(defaultValues);
        setAdvertisementDialog(true);
    };

    const hideDialog = () => {
        setAdvertisementDialog(false);
    };

    const hideDeleteAdvertisementDialog = () => {
        setDeleteAdvertisementDialog(false);
    };

    const editAdvertisement = (advertisement) => {
        setEdit(true);
        reset({
            id: advertisement.id,
            company: advertisement.company,
            website: advertisement.website,
            email: advertisement.email,
            phone: advertisement.phone,
            description: advertisement.description,
            release: new Date(advertisement.release),
            expire: new Date(advertisement.expire),
            activated: advertisement.activated === 1 ? true : false,
            photo: advertisement.photo
        });
        setAdvertisement({ ...advertisement });
        setAdvertisementDialog(true);
    };

    const confirmDeleteAdvertisement = (advertisement) => {
        setAdvertisement(advertisement);
        setDeleteAdvertisementDialog(true);
    };

    const previewAdvertisement = (advertisement) => {
        setAdvertisement(advertisement);
        setShowAdvertisementDialog(true);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label={t("New")} icon="pi pi-plus" severity="success" onClick={openNew} />
            </div>
        );
    };

    const rightToolbarTemplate = () => {
        return header;
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-eye" rounded outlined className="mr-2" style={{height:'2rem', width:'2rem'}} onClick={() => previewAdvertisement(rowData)} />
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" style={{height:'2rem', width:'2rem'}} onClick={() => editAdvertisement(rowData)} />
                <Button icon="pi pi-trash" rounded outlined severity="danger" style={{height:'2rem', width:'2rem'}} onClick={() => confirmDeleteAdvertisement(rowData)} />
            </React.Fragment>
        );
    };

    const dataFormat = (date) => {
        return (date.getDate() < 10 ? "0" : "") + date.getDate() + '-' + t(date.toLocaleString('default', { month: 'short' })) + '-' + date.getFullYear()
    }

    const onChangeSearch = (e) => {
        setGlobalFilter(e.target.value);
        setFilter({
            ...filter,
            'search': e.target.value
        })
    }

    const header = (
        <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
            <h4 className="m-0">All Advertisements</h4>
            <div className="flex">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={onChangeSearch} placeholder="Search..."  className="w-full"/>
                </span>
            </div>
            
        </div>
    );

    const OnDeleteAdvertisement = async () => {
        advertisement.id && await deleteAdvertisement(authHeader(), advertisement.id)
            .then((response) => {
                if (response.status === 200) {
                    getAdvertisement()
                    toast.current.show({ severity: 'info', detail: "Advertisement Deleted!", life: 3000 });
                } 
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', detail: "Something went wrong!", life: 3000 });
            });
        setDeleteAdvertisementDialog(false);
    };

    const deleteAdvertisementDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteAdvertisementDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={OnDeleteAdvertisement} />
        </React.Fragment>
    );

    const defaultValues = {
        id: undefined,
        company: '',
        website: '',
        email: '',
        phone: '',
        description: '',
        release: '',
        expire: '',
        activated: '',
        photo: ''
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setError
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error pt-1 pb-3 text-left">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const onSubmit = async (data) => {
        data = {...data, activated: data.activated ? 1 : 0}
        if (edit && data.id) {
            if (data.photo instanceof Blob) {
                await uploadAdvertisement(authHeader(), {file: data?.photo})
                .then((response) => {
                    data = {...data, photo: response?.data?.message};
                })
                .catch((error) => toast.current.show({ severity: 'error', detail: "Something went wrong!", life: 3000 }));
            }

            await updateAdvertisement(authHeader(), data, data.id)
            .then((response) => {
                if (response.status === 200) {
                    hideDialog();
                    getAdvertisement()
                    toast.current.show({ severity: 'info', detail: "Advertisement Updated!", life: 3000 });
                    reset(defaultValues)
                } 
            })
            .catch((error) => {
                if (error?.response?.status === 400) {
                    setError('name', {
                        type: "server",
                        message: error?.response?.data?.data,
                    });
                }
            });
        } else {
            data?.photo && await uploadAdvertisement(authHeader(), {file: data?.photo})
            .then((response) => {
                data = {...data, photo: response?.data?.message};
                createAdvertisement(authHeader(), data)
                .then((response) => {
                    if (response?.data?.respCd === "0000") {
                        hideDialog();
                        getAdvertisement()
                        toast.current.show({ severity: 'info', detail: "Advertisement Created!", life: 3000 });
                        reset(defaultValues)
                    } else if (response?.data?.respCd === "208") {
                        setError('name', {
                            type: "server",
                            message: response?.data?.message,
                        });
                    }
                })
                .catch((error) => console.log(error));
            })
            .catch((error) => toast.current.show({ severity: 'error', detail: "Something went wrong!", life: 3000 }));
        }
        
    };

    const statusBodyTemplate = (rowData) => {
        let status = '';
        if (rowData.activated === 1) {
            status = <Badge value="Yes" severity="success"></Badge>
        } else if (rowData.activated === 0) {
            status = <Badge value="No" severity="danger"></Badge>
        }
        return status;
    };

    const onUpload = (e, field) => {
        field.onChange(e.files[0])
    }
    
    return (
        <>
        {/* <div className="grid crud-demo">
            <div className="col-12"> */}
                <Toast ref={toast} />
                {/* <div className="card"> */}
                    <Toolbar className="mb-2" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={advertisements?.content}
                            dataKey="id"  paginator rowsPerPageOptions={[5, 10, 25, 50]}
                            lazy
                            first={firstPage}
                            rows={filter.perPage}
                            totalRecords={advertisements?.totalElements}
                            onPage={onPageChange}
                            onSort={onSort}
                            sortField={filter.sortField}
                            sortOrder={filter.sortOrder}
                            loading={loading}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
                            className="text-sm"
                    >
                        <Column field="id" header={t("ID")} headerClassName="font-bold" sortable></Column>
                        <Column field="company" header={t("Company")} headerClassName="font-bold" sortable></Column>
                        <Column field="website" header={t("Website")} headerClassName="font-bold" sortable></Column>
                        <Column field="photo" header={t("Photo")} headerClassName="font-bold" sortable></Column>
                        <Column field="description" header={t("Description")} headerClassName="font-bold" sortable></Column>
                        <Column field="email" header={t("Email")} headerClassName="font-bold" sortable></Column>
                        <Column field="phone" header={t("Phone")} headerClassName="font-bold" sortable></Column>
                        <Column field="release" header={t("Release")} headerClassName="font-bold" body={(e) => e.release && dataFormat(new Date(e.release))} sortable></Column>
                        <Column field="expire" header={t("Expire")} headerClassName="font-bold" body={(e) => e.expire && dataFormat(new Date(e.expire))} sortable></Column>
                        <Column field="activated" header={t("Activated")} headerClassName="font-bold" body={statusBodyTemplate} sortable></Column>
                        <Column field="created" header={t("Create")} headerClassName="font-bold" body={(e) => e.created && dataFormat(new Date(e.created))} sortable ></Column>
                        <Column field="modified" header={t("Modified")} headerClassName="font-bold" body={(e) => e.modified && dataFormat(new Date(e.modified))} sortable ></Column>
                        <Column header={t("Actions")} headerClassName="font-bold" body={actionBodyTemplate} style={{minWidth: '9rem'}} exportable={false} ></Column>
                    </DataTable>
                {/* </div> */}

                <Dialog visible={advertisementDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={edit ? 'Edit Advertisement' : "Add Advertisement"} modal className="p-fluid" onHide={hideDialog}>
                    <form onSubmit={handleSubmit(onSubmit)} className="pt-2 flex flex-column w-full">
                        <div className='grid'>
                            <Controller
                                name="id"
                                control={control}
                                render={({ field }) => (
                                    <input type="hidden" value={field.value}></input>
                                )}
                            />
                            <Controller
                                name="company"
                                control={control}
                                rules={{ required: 'Company is required.'}}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="company" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="company">{t('Company')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="website"
                                control={control}
                                rules={{ required: 'Website is required.'}}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="website" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="website">{t('Website')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="email"
                                control={control}
                                rules={{ required: 'Email is required.'}}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="email" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="email">{t('Email')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="phone"
                                control={control}
                                rules={{ required: 'Phone is required.'}}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="phone" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="phone">{t('Phone')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="description"
                                control={control}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <InputText id="description" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor="description">{t('Description')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="release"
                                control={control}
                                rules={{ 
                                    required: 'Release Date is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <Calendar value={field.value} onChange={(e) => field.onChange(e.target.value)} className=" w-full bg-login-card" dateFormat="yy-mm-dd" showButtonBar/>
                                            <label htmlFor="release" className="bg-login-card z-5">{t('Release Date')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="expire"
                                control={control}
                                rules={{ 
                                    required: 'Expire Date is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <Calendar value={field.value} onChange={(e) => field.onChange(e.target.value)} className=" w-full bg-login-card" dateFormat="yy-mm-dd" showButtonBar/>
                                            <label htmlFor="expire" className="bg-login-card z-5">{t('Expire Date')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="activated"
                                control={control}
                                render={({ field, fieldState }) => ( 
                                    <div className="col-6">
                                        <span className="p-float-label w-full">
                                            <Checkbox inputId="activated" name="pizza" value={field.value} onChange={(e) => {field.onChange(!field.value); setActive(!active)}} checked={field.value} />
                                            <label htmlFor="activated" className="ml-2">{t('Activated')}</label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </div>
                                )}
                            />
                            <Controller
                                name="photo"
                                control={control}
                                rules={{ 
                                    required: 'Expire Date is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <div className="col-12">
                                        <span className="p-float-label w-full">
                                            <FileUpload 
                                                name="photo" 
                                                url={'/api/upload'} 
                                                accept="image/*" 
                                                uploadOptions={{className:'hidden'}} 
                                                onSelect={e => {onUpload(e, field)}} 
                                                cancelOptions={{className:'hidden'}} 
                                                maxFileSize={1000000} 
                                                emptyTemplate={<p className="m-0">{photo ? <img className="w-full" src={'data:image/png;base64,'+photo}></img> : 'Drag and drop files to here to upload.'}</p>} 
                                            />
                                        </span>
                                    </div>
                                )}
                            />
                        </div>
                        <div className="flex justify-content-end">
                            <Button type="submit" label={t("Submit")} className="w-4 p-3 text-xl" ></Button>
                        </div>
                    </form>
                </Dialog>

                <Dialog visible={showAdvertisementDialog} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={() => <span style={{fontWeight: "700"}}>Advertisement Review</span>} modal className="p-fluid" onHide={() => setShowAdvertisementDialog(false)}>
                    <div className="grid">
                        <div className="col-4">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('ID')}</span>
                                <span className="font-bold">{advertisement?.id}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Email')}</span>
                                <span className="font-bold">{advertisement.email ?? '---'}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Release Date')}</span>
                                <span className="font-bold">{advertisement.release ? dataFormat(new Date(advertisement.release)) : '---'}</span>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Company')}</span>
                                <span className="font-bold">{advertisement.company ?? '---'}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Phone')}</span>
                                <span className="font-bold">{advertisement.phone ?? '---'}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Expire Date')}</span>
                                <span className="font-bold">{advertisement.expire ? dataFormat(new Date(advertisement.expire)) : '---'}</span>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Website')}</span>
                                <span className="font-bold">{advertisement?.website ?? '---'}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Description')}</span>
                                <span className="font-bold">{advertisement.description ?? '---'}</span>
                            </div>
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Activation')}</span>
                                <span className="font-bold">{statusBodyTemplate(advertisement)}</span>
                            </div>
                        </div>
                        <div className="col-8">
                            <div className="flex flex-column gap-1 mb-3">
                                <span>{t('Photo')}</span>
                                {photo && <img className="w-full" src={'data:image/png;base64,'+photo}></img>}
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={deleteAdvertisementDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Delete Advertisement" modal footer={deleteAdvertisementDialogFooter} onHide={hideDeleteAdvertisementDialog}>
                    <div className="confirmation-content">
                        {advertisement && (
                            <span>
                                {t('Are you sure you want to delete')} advertisement ID:<b>{advertisement.id}</b>?
                            </span>
                        )}
                    </div>
                </Dialog>
        {/*      </div> */}
        {/*  </div> */}
    </>
    )
}